// extracted by mini-css-extract-plugin
export default {"hero_section":"hero_hero_section__jthgz","hero":"hero_hero__qf9jn","hero_btns":"hero_hero_btns__K2a9Z"};